import { inject, Service, signal } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, tap } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TreeSkillsStore } from '@app/pages/home/tree/store/tree-skills.store';

@Service()
export class SearchService {
  $currentSearch = signal<string>('');

  constructor() {
    inject(TreeSkillsStore).connectSearch(this.$currentSearch);
    inject(ActivatedRoute)
      .queryParamMap.pipe(
        takeUntilDestroyed(),
        map((paramMap: ParamMap) => paramMap.get('search')),
        filter((search): search is string => !!search),
        tap(search => this.$currentSearch.set(search)),
      )
      .subscribe();
  }
}
